import { useQuery } from '@tanstack/react-query';

import fetch from 'logic/rest/FetchProvider';
import { qualifyUrl } from 'util/URLUtils';
import { defaultOnError } from 'util/conditional/onError';
import useLicenseCheck from 'license/useLicenseCheck';

const urlPrefix = '/plugins/org.graylog.plugins.securityapp.investigations/ai/config';

type AIConfigurationJson = {
  investigations_ai_reports_enabled: boolean;
};

export type AIConfigurationType = {
  isEnabled: boolean;
};

export const AI_CONFIGURATION_QUERY_STRING = 'ai-configuration';
const getAIReportConfiguration = (): Promise<AIConfigurationType> =>
  fetch('GET', qualifyUrl(urlPrefix)).then((response: AIConfigurationJson) => ({
    isEnabled: response?.investigations_ai_reports_enabled !== false,
  }));

const useAIConfiguration = (): {
  data: AIConfigurationType;
  isLoading: boolean;
} => {
  const {
    security: { isValid: validSecurityLicense },
    enterprise: { isValid: validEnterpriseLicense },
  } = useLicenseCheck();

  const hasValidLicense = validSecurityLicense || validEnterpriseLicense;

  const { data, isLoading } = useQuery({
    queryKey: [AI_CONFIGURATION_QUERY_STRING],
    queryFn: () =>
      defaultOnError(
        getAIReportConfiguration(),
        'Fetching AI Configuration with status',
        'Could not fetch AI Configuration',
      ),
    enabled: hasValidLicense,
  });

  return {
    data: data ?? {
      isEnabled: false,
    },
    isLoading,
  };
};

export default useAIConfiguration;
